import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, Ref, ref, watch } from 'vue'
import moment, { Moment } from 'moment'

import CellBase from '@/components/weekly-schedule/calendar/CellBase.vue'
import JobCell from '@/components/weekly-schedule/JobCell.vue'
import EventCellJobDetails from '@/components/weekly-schedule/EventCellJobDetails.vue'
import CalendarGrid from '@/components/weekly-schedule/CalendarGrid.vue'
import { Item } from '@/components/weekly-schedule/utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'AssignmentGroupCell',
  props: {
    jobs: null,
    weekStart: null
  },
  emits: ["drop:group", "select:group", "context:group", "drag:group"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'drop:group', groupNumber: string, dragEvent: DragEvent)
  (
    event: 'select:group',
    assignmentGroupId: string,
    jobs: Item[],
    mouseEvent: MouseEvent
  ): void
  (
    event: 'context:group',
    assignmentGroupId: string,
    jobs: Item[],
    mouseEvent: MouseEvent
  ): void
  (
    event: 'drag:group',
    assignmentGroupId: string,
    jobs: Item[],
    dragEvent: DragEvent
  ): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { jobs: Item[]; weekStart: Moment }




const isDragging = inject<Ref<boolean>>('isDragging', ref(false))
const expanded = ref(false)
const isDragTarget = ref(false)

const isSaving = computed(() => props.jobs.some((j) => j.isSaving))
const selected = computed(() => props.jobs.every((j) => j.isSelected))

const groupLeader = computed(() => props.jobs[0])

const assignmentGroupId = computed<string>(
  () => groupLeader.value.assignmentGroupId || ''
)

const color = computed(() => groupLeader.value.division?.hexCode)
const jobCountDisplay = computed(() => {
  const count = props.jobs.length
  return count > 1 ? `${count}` : ''
})

const start = computed(() => {
  return moment.min(props.jobs.map((j) => j.displayedStartTime))
})
const end = computed(() => {
  return moment.max(props.jobs.map((j) => j.displayedEndTime))
})

const expandedCalendarStart = computed(() => {
  return moment.max(props.weekStart, start.value)
})
const expandedCalendarEnd = computed(() => {
  return moment.min(moment(props.weekStart).endOf('week'), end.value)
})

const allJobsComplete = computed<boolean>(() => {
  return props.jobs.every((j) => j.isCompleted)
})

const hasCompletedJob = computed<boolean>(() => {
  return !!props.jobs.find((job) => job.isCompleted)
})

function onDrop(dragEvent: DragEvent) {
  emit('drop:group', assignmentGroupId.value, dragEvent)
}

function onGroupClick() {
  expanded.value = !expanded.value
}

function onGroupCtrlClick(mouseEvent: MouseEvent) {
  emit('select:group', assignmentGroupId.value, props.jobs, mouseEvent)
}

function onGroupContextMenu(mouseEvent: MouseEvent) {
  emit('context:group', assignmentGroupId.value, props.jobs, mouseEvent)
}

function onGroupDrag(dragEvent: DragEvent) {
  emit('drag:group', assignmentGroupId.value, props.jobs, dragEvent)
}

function onDragOver(dragEvent: DragEvent) {
  dragEvent.preventDefault()
}

function onDragEnter(dragEvent: DragEvent) {
  isDragTarget.value = true

  dragEvent.preventDefault()
}

function onDragLeave() {
  isDragTarget.value = false
}

watch(isDragging, () => {
  if (!isDragging.value) {
    isDragTarget.value = false
  }
})

return { __sfc: true,props, emit, isDragging, expanded, isDragTarget, isSaving, selected, groupLeader, assignmentGroupId, color, jobCountDisplay, start, end, expandedCalendarStart, expandedCalendarEnd, allJobsComplete, hasCompletedJob, onDrop, onGroupClick, onGroupCtrlClick, onGroupContextMenu, onGroupDrag, onDragOver, onDragEnter, onDragLeave, CellBase, JobCell, EventCellJobDetails, CalendarGrid }
}

})